<template>
  <div >
    {{label || title}}
    <div class="elevation-2 pl-2 pr-2 pt-2 pb-2">
    <k-layout v-if="add == true">
      <k-flex c5 class="pr-1">
        <k-autocomplete :items="field_types" v-model="add_field_type" label="Field type"></k-autocomplete>
      </k-flex>
      <k-flex c5 class="pr-1">
        <k-text-field v-model="add_field_name" label="Key"></k-text-field>
      </k-flex>
      <k-flex c2 class="pr-1">
        <k-btn size="xs" color="success" @click="add_field">Add</k-btn>
      </k-flex>
    </k-layout>
    <div v-for="field in fields">
      <component v-bind:is="get_field_type(field.type)" v-bind="field" v-model="val" :ref="field.name"></component>
    </div>
  </div>
  </div>
</template>
  
<script>
import * as FormItems from '.'
import ContentModel from '@/models/content.js'

export default {
	props: {
		'name': String,
	  'value': {
      type: Object,
      default () { return {}; }
    },
		'label': String,
    'title': String,
    'default_fields': Array,
    'add': {
      type: Boolean,
      default () {return false; }
    }
	},
  data() {
    return {
      fields: this.fix_fields(this.default_fields) || [],
      "add_field_type": undefined,
      "add_field_name": undefined,
      "orig_val": {}
    };
  },  
  components: {
    ...FormItems
  },
  methods: {
    fix_fields(fields) {
      if (typeof(fields) != "undefined") {
        return _.map(fields, (field) => {
          return {
            "type": field.type,
            "name": field.name,
            "title": field.name
          };
        });
      } else {
        return undefined;
      }
    },
    add_field() {
      var field = {
        "type": this.add_field_type,
        "title": this.add_field_name,
        "name": this.add_field_name
      }
      this.fields.push(field);
      this.add_field_type = undefined;
      this.add_field_name = undefined;
    },

    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
  },
	computed: {
    field_types () {
      var types = ContentModel.field_types();
      return Object.keys(types);
    },
    val: {
      get () {
        return _.get(this.value, this.name) || {};
      },
      set (val) {
        console.log(val);
        console.log(this.value);
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>